export default { // 改需求为临时需求，入口评估app首页 =》 速卖服务   http://wiki.renrenaiche.cn/pages/viewpage.action?pageId=39701778
  tabs: [{
    name: 'FastSelling',
    path: '/fastSelling/detail/:type',
    component: () => import('./src/detail.vue'),
    meta: {
      title: '个人直卖服务',
      isMenu: true
    }
  },
  {
    name: 'FastSellingOwner',
    path: '/fastSelling/ownerDetail/:type',
    component: () => import('./src/ownerDetail.vue'),
    meta: {
      title: '个人直卖服务',
      isMenu: true
    }
  }]
}
